/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckIcaoSex } from './PaxCheckIcaoSex';
import {
    PaxCheckIcaoSexFromJSON,
    PaxCheckIcaoSexFromJSONTyped,
    PaxCheckIcaoSexToJSON,
    PaxCheckIcaoSexToJSONTyped,
} from './PaxCheckIcaoSex';

/**
 * Travel document structure for manual input using /apply-document/travel-document
 * @export
 * @interface PaxCheckTravelDocument
 */
export interface PaxCheckTravelDocument {
    /**
     * Type of travel document, see checklist.possible_travel_documents for allowed types for this journey
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    documentType: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    number: string;
    /**
     * 
     * @type {Date}
     * @memberof PaxCheckTravelDocument
     */
    expiryDate: Date;
    /**
     * ISO 3166-1 alpha-3 https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    surname?: string | null;
    /**
     * 
     * @type {PaxCheckIcaoSex}
     * @memberof PaxCheckTravelDocument
     */
    sex?: PaxCheckIcaoSex;
    /**
     * 
     * @type {Date}
     * @memberof PaxCheckTravelDocument
     */
    birthdate: Date;
    /**
     * ISO 3166-1 alpha-3 https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    nationality: string;
    /**
     * Provided document sub type (eg DIPLOMATIC for passport)
     * @type {string}
     * @memberof PaxCheckTravelDocument
     */
    subType?: string | null;
}



/**
 * Check if a given object implements the PaxCheckTravelDocument interface.
 */
export function instanceOfPaxCheckTravelDocument(value: object): value is PaxCheckTravelDocument {
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('expiryDate' in value) || value['expiryDate'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('birthdate' in value) || value['birthdate'] === undefined) return false;
    if (!('nationality' in value) || value['nationality'] === undefined) return false;
    return true;
}

export function PaxCheckTravelDocumentFromJSON(json: any): PaxCheckTravelDocument {
    return PaxCheckTravelDocumentFromJSONTyped(json, false);
}

export function PaxCheckTravelDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckTravelDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'documentType': json['document_type'],
        'number': json['number'],
        'expiryDate': (new Date(json['expiry_date'])),
        'countryCode': json['country_code'],
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'sex': json['sex'] == null ? undefined : PaxCheckIcaoSexFromJSON(json['sex']),
        'birthdate': (new Date(json['birthdate'])),
        'nationality': json['nationality'],
        'subType': json['sub_type'] == null ? undefined : json['sub_type'],
    };
}

export function PaxCheckTravelDocumentToJSON(json: any): PaxCheckTravelDocument {
    return PaxCheckTravelDocumentToJSONTyped(json, false);
}

export function PaxCheckTravelDocumentToJSONTyped(value?: PaxCheckTravelDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_type': value['documentType'],
        'number': value['number'],
        'expiry_date': ((value['expiryDate']).toISOString().substring(0,10)),
        'country_code': value['countryCode'],
        'given_name': value['givenName'],
        'surname': value['surname'],
        'sex': PaxCheckIcaoSexToJSON(value['sex']),
        'birthdate': ((value['birthdate']).toISOString().substring(0,10)),
        'nationality': value['nationality'],
        'sub_type': value['subType'],
    };
}

